// extracted by mini-css-extract-plugin
module.exports = {"item":"PlayerItem_item__fLdXu","add":"PlayerItem_add__3KQQY","remove":"PlayerItem_remove__8dJTL"};